import React, { useState, useEffect } from 'react';

import { Page, PageContent, PageHeader } from '@vlabs/monokit/shared/ui/page';
import { actionColumnProps } from '@vlabs/shared/utils';
import {
  Panel, Table, TableCells, Modal, openConfirmPopup, Breadcrumb, Breadcrumbs,
} from '@vlabs/uikit';
import { useTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import { useHistory } from 'react-router-dom';

import PlansForm from './PlansForm';
import { selectSlice } from './selectors';
import {
  fetchPlans, submitPlan, deletePlan, setPageSize, setPage,
} from './store';
import { ImageCell } from '../components/image-cell/ImageCell';

function PlansListPageComponent({
  plans,
  fetchPlans,
  submitPlan,
  deletePlan,
  setPageIndex,
  setPageSize,
}) {
  const { t } = useTranslation();
  const history = useHistory();

  const [modalIsOpen, setModalIsOpen] = useState(false);
  const [selectedPlan, setSelectedPlan] = useState(undefined);

  const closeModal = () => {
    setSelectedPlan(undefined);
    setModalIsOpen(false);
  };

  const openModal = (plan) => {
    setSelectedPlan(plan);
    setModalIsOpen(true);
  };

  useEffect(() => {
    fetchPlans();
  }, [fetchPlans]);

  const onFormSubmit = (values) => {
    submitPlan(values);
    setModalIsOpen(false);
  };

  const $deletePlan = ({ id }) => {
    const message = t('plans:confirmation.delete.message');

    const onConfirm = async () => {
      deletePlan(id);
    };

    openConfirmPopup({
      title: t('plans:confirmation.delete.title'),
      message,
      type: 'delete',
      onConfirm,
    });
  };

  return (
    <Page>
      <Modal
        appElement={document.getElementById('root')}
        isOpen={modalIsOpen}
        onRequestClose={closeModal}
      >
        <PlansForm
          defaultValues={selectedPlan}
          onSubmit={onFormSubmit}
        />
      </Modal>
      <PageContent>
        <PageHeader
          breadcrumbs={(
            <Breadcrumbs>
              <Breadcrumb caption={t('plans:page_title')} />
            </Breadcrumbs>
          )}
        />
      <Panel className="PanelAutoHeight">
        <Table
          columns={[
            {
              Header: t('plans:plan_id'),
              accessor: 'id',
            },
            {
              Header: t('plans:plan_name'),
              accessor: 'name',
            },
            {
              Header: t('plans:plan'),
              accessor: 'plan_image_url',
              Cell: ({ value }) => ImageCell(value),
            },
            actionColumnProps({
              id: 'action2',
              type: 'action',
              Cell: TableCells.EditCell,
            }),
            actionColumnProps({
              id: 'action3',
              type: 'action',
              Cell: TableCells.DeleteCell,
            })]}
          data={plans.pageData}
          onActions={{
            onAddRow: { handler: openModal },
            onEditRow: { handler: openModal },
            onClickRow: { handler: (data) => history.push(`/plans/${data.id}/calibrations`) },
            onDeleteRow: { handler: $deletePlan },
          }}
          pageIndex={plans.pageIndex}
          pageSize={plans.pageSize}
          pageSizeOptions={plans.pageSizeOptions}
          paginationType="offsetBased"
          setPageIndex={setPageIndex}
          setPageSize={setPageSize}
        />
      </Panel>
      </PageContent>
    </Page>
  );
}

export const PlansListPage = connect(
  (state) => ({
    plans: selectSlice(state),
  }),
  (dispatch) => ({
    fetchPlans: () => dispatch(fetchPlans),
    submitPlan: (params) => dispatch(submitPlan(params)),
    deletePlan: (id) => dispatch(deletePlan(id)),
    setPageSize: (pageSize) => dispatch(setPageSize({ pageSize })),
    setPageIndex: (pageIndex) => dispatch(setPage({ pageIndex })),
  }),
)(PlansListPageComponent);
